import { useQuery } from "react-query";
import api from "../services/api";
import queryKeys from "./queryKeys";

const WHATSAPPS_CACHE_TTL = 15 * 60 * 1000;

const fetchWhatsApps = async ({ queryKey }) => {
  const [, , params] = queryKey;
  const { data } = await api.get("/whatsapp/", {
    params: {
      session: params?.session ?? 0,
    },
  });
  return data || [];
};

export const useWhatsAppsListQuery = ({ companyId, enabled = true, session = 0 }) =>
  useQuery(queryKeys.whatsApps.list(companyId, { session }), fetchWhatsApps, {
    enabled: Boolean(companyId) && enabled,
    meta: {
      persist: {
        maxAge: WHATSAPPS_CACHE_TTL,
      },
    },
  });
